module.exports = "<app-issue-menu></app-issue-menu>\n<span class=\"clearfix\"></span>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/issues/issues.component.html
// module id = ./src/app/issues/issues.component.html
// module chunks = main